import { z } from 'zod';
import { routingProfilesSchema } from './routing-profile.schema';

export const routingProfilePagedCollectionSchema = z.object({
  size: z.number().min(0),
  data: routingProfilesSchema,
});

export type RoutingProfilePagedCollection = z.infer<
  typeof routingProfilePagedCollectionSchema
>;
